import AppRuter from "./Utils/Routes/AppRoutes";


const App = () => {
  return <AppRuter />;
}
 
export default App;
